import {ThemeType} from 'frontend/themes/enum/theme-type'
import {computed, ref, watch} from 'vue'
import {createGlobalState, useStorage} from '@vueuse/core'
import {appModule} from 'frontend/_config/modules'
import {useRoute} from 'vue-router'

export const useTheme = createGlobalState(() => {
  const currentThemeType = useStorage('theme', ThemeType.Light) // returns Ref<boolean>
  const route = useRoute()

  const isDarkModeEnabled = computed({
    get() {
      return currentThemeType.value === ThemeType.Dark
    },
    set(value: boolean) {
      currentThemeType.value = value ? ThemeType.Dark : ThemeType.Light
    }
  })

  const realCurrentTheme = computed({
    get() {
      if(route.meta.module === appModule.PASSENGER) {
        return ThemeType.Light
      }
      return currentThemeType.value
    },
    set(value: ThemeType) {
      currentThemeType.value = value
    }
  })

  watch(realCurrentTheme, (value) => {
    document.body.setAttribute('data-theme', value)
  }, {
    immediate: true,
  })

  return {
    currentThemeType: realCurrentTheme,
    isDarkModeEnabled,
  }
})
